<template>
  <div id="app">
    <landscape-tip v-if="isLandscape"></landscape-tip>
    <router-view/>
  </div>
</template>
<script>
import LandscapeTip from '@/components/LandscapeTip';
export default {
  name: 'App',
  data () {
    return {
      isLandscape: false
    };
  },
  components: {
    LandscapeTip
  },
  mounted () {
    this.initEvent();
  },
  methods: {
    initEvent () {
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.judgeScoreDirection, false);
    },
    judgeScoreDirection () {
      const orientation = window.orientation;
      if (orientation === 180 || orientation === 0) {
        this.isLandscape = false;
      }
      if (orientation === 90 || orientation === -90) {
        this.isLandscape = true;
      }
    }
  }
};
</script>
<style lang="scss">

</style>
